import React, { useContext, useEffect, useState } from "react";
import Board from "./Board";
import { fetchWithToken } from "../../../api/fetch";
import { ChatContext } from "../../../context/chat/ChatContext";
import { types } from "../../../types/types";

const MainListChat = ({ openChatTab }) => {
  const { dispatch } = useContext(ChatContext);

  useEffect(() => {
    loadInitialChats();
  }, []);

  const loadInitialChats = async () => {
    const resp = await fetchWithToken(`cats`);
    if (resp.ok) {
      dispatch({ type: types.loadChatsCat, payload: resp.data });
    }
  };

  return (
    <div className="bg-light">
      <Board openChat={openChatTab} />
    </div>
  );
};

export default MainListChat;
